import ErrorSignIcon from 'components/assets/error-sign.svg';
import { memo } from 'react';
import { isDeepEqual } from 'remeda';

import './_style.scss';

interface Props {
    shouldRender: boolean;
}

const SystemHealthNotification = () => (
    <div className='SystemHealthNotification'>
        <img src={ErrorSignIcon} className='SystemHealthNotification__icon' />
        <p className='SystemHealthNotification__message'>
            <b>We&apos;re currently experiencing technical issues.</b> Some functionalities may be affected.
        </p>
    </div>
);

const arePropsEqual = (prevProps: Props, nextProps: Props) =>
    isDeepEqual(prevProps.shouldRender, nextProps.shouldRender);

export default memo(SystemHealthNotification, arePropsEqual);
